import { isObject, isString } from './typeGuards';
/**
 * This is a collection of typesafe helpers to work with Error-like objects
 */

/**
 * Extracts a message from an Error-like object
 * @param err an Error-like object
 * @returns message
 */
export const getMessage = (err: unknown): string | null => {
  if (isString(err)) {
    return err;
  }
  if (isObject(err)) {
    if ('message' in err && isString(err.message)) {
      return err.message;
    }
  }
  return null;
};

export default { getMessage };
